import {PageContainer} from '@/components/organisms';
import {Actions} from '@/containers/ClubPlus/Tabs/Overview/Actions';
import {TiersChart} from '@/containers/ClubPlus/Tabs/Overview/TiersChart/TiersChart';
import {
  getTiersChart,
  mapTiersToLegendItems
} from '@/containers/ClubPlus/Tabs/Overview/TiersChart/TiersChart.utils';
import {useActiveTiers} from '@/containers/ClubPlus/hooks/useActiveTiers';
import {TierList} from '@/containers/ClubPlus/Tabs/Overview/TierList/TierList';

export const OverviewTab = () => {
  const {tiers} = useActiveTiers();
  const tierData = getTiersChart(tiers || []);
  const filteredTiers = tierData.list.filter(
    (item) => item.storesAssociated > 0
  );
  const legendItems = mapTiersToLegendItems(tiers || []);

  const segments = filteredTiers.map((item) => ({
    name: item.name,
    color: '#' + item.color,
    size: item.size,
    quantityLabel: item.quantityLabel
  }));

  return (
    <PageContainer data-testid='overview-tab' key='overview'>
      {filteredTiers.length > 0 && (
        <TiersChart
          mode='store'
          leftLabel='Tiers'
          segments={segments}
          rightLabel={tierData.totalStores}
          legendItems={legendItems.filter((item) => item.quantity > 0)}
        />
      )}
      <Actions />
      <TierList />
    </PageContainer>
  );
};
